import {fetchProjectData} from '../../../services/reportServices'
import {reportListActions} from '../report'

const getProjectDataAction = (payload) => {
  return (dispatch) => {
    dispatch(reportListActions.projectDataListRequest())
    fetchProjectData(payload).then((res) => {
      dispatch(reportListActions.projectDataListSuccess(res))
    }).catch((error) => {
      dispatch(reportListActions.projectDataListFailure(error))
    })

  }
}

export default getProjectDataAction
